<template>
  <div  z-index="1000000">
  <el-button type="text" @click="dialogVisible = true">选择商品</el-button>

  <el-dialog
    title="选择菜品"
    :visible.sync="dialogVisible"
    width="30%"
    @open="initData"
    @opened="initToggleSelection"
    append-to-body

  >

    <div class="fillcontain" v-if="dialogVisible">
      <div class="table_container">
        <el-row>
          <el-col :span="12">
            <el-input placeholder="请输入菜品名字或编号查询" v-model="gpages.keyword" class="input-with-select">
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-button @click="getGoods" style="margin-left: 10px">搜索</el-button>
          </el-col>
        </el-row>
        <br/>
        <el-table
          :data="tableData"
          style="width: 100%"
          ref="multipleTable"
          @selection-change="handleSelectionChange"

          row-key="id"
          v-loading="loading">
          <el-table-column
            type="selection"
            width="55"
            prop="id"
          >
          </el-table-column>
          <el-table-column label="主图">
            <template slot-scope="scope">
              <img :src="scope.row.pics[0].showThumbnail" v-if="scope.row.pics.length > 0" width="50" height="50"/>
            </template>
          </el-table-column>
          <el-table-column
            label="菜名"
            prop="name">
          </el-table-column>

          <el-table-column
            label="编号"
            prop="number">
          </el-table-column>
          <el-table-column
            label="销售价"
            :formatter="sellPriceFormat">
          </el-table-column>

          <el-table-column
            label="状态"
            :formatter="statusFormat">
          </el-table-column>
        </el-table>
        <div class="Pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="gpages.page"
            :page-size="gpages.pageSize"
            layout="total, prev, pager, next"
            :total="gpages.total">
          </el-pagination>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="saveHandle">确 定</el-button>
  </span>
  </el-dialog>

  </div>
</template>

<script>
export default {
  props: {
    checkBox: {
      type: String,
      default:"checkbox"
    },
    initGoods:{
      type:Array,
      default: () => []
    }
  },
  data(){
    return {
      radio:"",
      baseUrl:window.server.baseUrl,
      uploadUrl:window.server.baseUrl+'/common/imageUpload',
      loading:false,
      dialogVisible: false,
      choose:true,
      gpages:{
        offset: 0,
        pageSize: 2,
        page: 1,
        total: 0,
        keyword:"",
      },
      tableData: [],
      multipleSelection: [],
      chooseGoods:[],
      hasSelectList:[],
      isInit:false
    }
  },
  created(){
  },
  mounted() {
  },
  methods: {
    initData() {
      var that = this;
      this.hasSelectList = [];
      this.chooseGoods = [];
      if(this.initGoods.length > 0){
        this.initGoods.forEach(row => {
          this.hasSelectList.push(row.id);
          this.chooseGoods.push(row);
        })
      }
      this.getGoods();
    },
    getGoods(){
      var that = this;
      this.loading = true;
      that.$api.get('/store/goods', that.gpages, response => {
        if (response.status >= 200 && response.status < 300) {
          var res = response.data;
          if (res.code == 0) {

            this.isInit = true;
            that.tableData = res.data.goods.content;
            that.gpages.total = res.data.goods.totalElements;
            console.log("=======3=========")
            console.log(that.hasSelectList)
            console.log("=======3=========")
            this.$nextTick(()=>{

              that.tableData.forEach(row => {


                console.log("默22认"+row.id)
                if(that.hasSelectList.indexOf(row.id) >= 0){
                  console.log("默认"+row.id)
                  that.$refs.multipleTable.toggleRowSelection(row,true);
                }
              })

              this.isInit = false;
            })
          }else{
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        } else {
          this.$message({
            message: "服务器维护中",
            type: 'error'
          });
        }
        this.loading = false;
      });

    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.gpages.page = val;
      this.gpages.offset = (val - 1)*this.gpages.pageSize;
      this.getGoods()
    },
    statusFormat(row,column){
      return row.status == 2?"上架":"下架";
    },
    sellPriceFormat(row,column){
      return row.sell_price/100;
    },

    handleSelectionChange(val) {
      if(this.isInit == true){
          return;
      }
      var newGoods = [];

      this.hasSelectList = [];//当前有选中的id
      if(this.chooseGoods.length > 0){
        this.chooseGoods.forEach(row => {
          this.hasSelectList.push(row.id);
        })
      }
      //查找出当前页面选中和非选中的
      var hasSelectListIDs = [];//当前页选中的
      if(val.length > 0){
        val.forEach(row => {
          hasSelectListIDs.push(row.id);
          if(this.hasSelectList.indexOf(row.id) < 0) {//不在选中里面，则要加入
            this.chooseGoods.push(row);
          }
        })
      }

      if(this.tableData.length > 0) {
        this.tableData.forEach(row => {
          if(hasSelectListIDs.indexOf(row.id) < 0 && this.hasSelectList.indexOf(row.id) >= 0) {//当前页面未选中的，如果在已选中移除
             this.removeAaary(this.chooseGoods,row.id);
          }
        })
      }
      this.multipleSelection = val;
      console.log("=======1=========")
      console.log(this.chooseGoods)
      console.log("=======1=========")
      this.hasSelectList = [];
      if(this.chooseGoods.length > 0){
        this.chooseGoods.forEach(row => {
          this.hasSelectList.push(row.id);
        })
      }
      console.log("=======2=========")
      console.log(this.hasSelectList)
      console.log("=======2=========")
    },
    removeAaary(_arr, _obj) {
      var length = _arr.length;
      for (var i = 0; i < length; i++) {
        if (_arr[i].id == _obj) {
          if (i == 0) {
            _arr.shift(); //删除并返回数组的第一个元素
            return _arr;
          }
          else if (i == length - 1) {
            _arr.pop();  //删除并返回数组的最后一个元素
            return _arr;
          }
          else {
            _arr.splice(i, 1); //删除下标为i的元素
            return _arr;
          }
        }
      }
    },
    initToggleSelection(){
      /**
      var that = this;
      if(this.initGoods.length > 0){
        console.log("1111");
        console.log(that.initGoods);
        console.log("2222");
        this.toggleSelection(that.initGoods);
      }
       **/

    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row,true);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    saveHandle(){
      this.$emit('goods', this.chooseGoods);
      this.dialogVisible = false;
    }


  },
}
</script>

<style lang="less">
@import '../../style/mixin';
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.table_container{
  padding: 20px;
  text-align: left;
}
.Pagination{
  display: flex;
  justify-content: flex-start;
  margin-top: 8px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #20a0ff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/goods/goods.vue